/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import { getBenefits } from '../../../redux/actions/benefitsActions';
import Table from '../../../shared/components/MaterialTable';

const headers = [
  { id: 'id', label: 'ID' },
  { id: 'name', label: 'Nombre' },
  { id: 'description', label: 'Descripción' },
  { id: 'status', label: 'Estado' },
  { id: 'actions', label: 'Acciones' },
];

class BenefitsTable extends Component {
  componentDidMount() {
    const { getData } = this.props;
    getData();
  }

  viewDetail() {
    const { history } = this.props;
    history.push('/beneficios/1');
  }

  render() {
    const { collection, loading } = this.props;
    const page = 0;
    const limit = 10;
    const data = collection.map(item => ({
      id: item.id,
      cells: (
        <Fragment>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
            {item.id}
          </TableCell>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
            {item.name}
          </TableCell>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
            {item.description}
          </TableCell>
          <TableCell className="material-table__cell" style={{ borderBottom: '0px' }} align="left">
            {item.status}
          </TableCell>
          <TableCell className="material-table__cell" align="left">
            <button className="table-button" type="button" onClick={() => this.viewDetail()}>
              <span
                className="lnr lnr-lnr lnr-eye"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </button>
          </TableCell>
        </Fragment>
      ),
    }));
    return (
      <div className="clients container">
        <Table
          cargando={loading}
          data={data}
          headers={headers}
          page={page}
          rowsPerPage={limit}
          selected={[]}
          total={data.length}
          onChangePage={this.onChangePage}
          // onChangeRowsPerPage={this.onChangeLimit}
        />
      </div>
    );
  }
}

BenefitsTable.propTypes = {
  collection: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getData: PropTypes.func.isRequired,
};

const mapState = ({ benefits }) => ({
  collection: benefits.collection,
  loading: benefits.loading,
});

const mapDispatch = {
  getData: getBenefits,
};

export default connect(mapState, mapDispatch)(BenefitsTable);
